module.exports = __webpack_public_path__ + "static/img/def-data_1.4d86b231.png";